import React from 'react';
import { useHistory } from 'react-router-dom';

import { Formik, Form, FormikValues } from 'formik';
import * as yup from 'yup';

import ResponsiveInput from 'components/ResponsiveInput';
import useStoreTranslation from 'hooks/useStoreTranslation';

import { Container, Header, FieldsContainer, BackButton, NextButton, ButtonsContainer, ButtonLine } from '../../styles';

export interface EmailValues {
  email: string;
}

interface Props {
  values: EmailValues | null;
  onSubmit: (values: EmailValues) => void;
}

const Email = ({ values, onSubmit }: Props) => {
  const { t } = useStoreTranslation();
  const history = useHistory();

  const validationSchema = yup.object().shape({
    email: yup.string().email().noPlusSign().required(),
  });

  const initialValues: EmailValues = {
    email: '',
  };

  const handleBack = () => history.goBack();

  const handleSubmit = async (formValues: EmailValues) => onSubmit(formValues);

  return (
    <Formik
      initialStatus={{ rightCheckIfIsValid: true }}
      initialValues={values || initialValues}
      isInitialValid={(formik: any) => validationSchema.isValidSync(formik.initialValues)}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
    >
      {({ isValid }: FormikValues) => (
        <Form>
          <Container>
            <Header>{t('registrationOnboarding.email.title')}</Header>

            <FieldsContainer>
              <ResponsiveInput name="email" placeholder={t('registrationOnboarding.email.placeholder')} type="email" />
            </FieldsContainer>

            <ButtonsContainer>
              <ButtonLine>
                <BackButton type="button" onClick={handleBack}>
                  {t('registrationOnboarding.backButton')}
                </BackButton>
                <NextButton disabled={!isValid}>{t('registrationOnboarding.nextButton')}</NextButton>
              </ButtonLine>
            </ButtonsContainer>
          </Container>
        </Form>
      )}
    </Formik>
  );
};

export default Email;
